import { useContext, useEffect, useState } from "react";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import PersonAddAlt1RoundedIcon from "@mui/icons-material/PersonAddAlt1Rounded";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";
import IconFilter from "../../../ui/icons-seleccion/IconFilter";
import IconFilterFull from "../../../ui/icons-seleccion/IconFilterFull";
import IconDescargaNomina from "../../../ui/icons-seleccion/IconDescargaNomina";
import IconCargando from "../../../ui/icons-seleccion/IconCargando";
import { PROFILE_ADMIN_SEL } from "../../../../diccionary/Diccionary";
import FiltroGenerico from "../../../ui/kit-modal/FiltroGenerico";
import InputFiltro from "../../../ui/kit-modal/Filtros-kit/InputFiltro";
import DropDownListMultipleFiltro from "../../../ui/kit-modal/Filtros-kit/DropDownListMultipleFiltro";
import Tooltip from "../../../ui/kit-mdtw/tooltip/Tooltip";
import ModalRestaurarInhabilitada from "./ModalRestaurarInhabilitada";
import CargaNominaInhabilitados from "../../../ui/groups/CargaNominaInhabilitados";
import CargaManualInhabilitados from "../../../ui/groups/CargaManualInhabilitados";
import FilterChips from "../../../ui/FilterChips";

// Etiquetas legibles para los chips de "Filtros activos" de esta tabla.
const INHAB_FILTER_LABELS: Record<string, string> = {
  dni: "RUT",
  nombre: "Nombre",
  tipo: "Motivo",
  nivel: "Tipo",
  clienteNombre: "Cliente",
  areaNegocioCod: "Área Negocio",
  busquedaId: "Proceso",
  usuario: "Usuario",
  fecha: "Fecha Inhabilitación",
};

const TIPO_OPTIONS = [
  { name: "Conducta Inadecuada", code: "Conducta Inadecuada" },
  { name: "Comparendo", code: "Comparendo" },
  { name: "Proceso Judicial", code: "Proceso Judicial" },
  { name: "Antecedentes Penales", code: "Antecedentes Penales" },
  { name: "Rol General", code: "Rol General" },
  { name: "Finiquito", code: "Finiquito" },
  { name: "Baja Confirmada", code: "Baja Confirmada" },
  { name: "Rol Privado", code: "Rol Privado" },
  { name: "Candidato desiste", code: "Candidato desiste" },
  { name: "No cumple perfil", code: "No cumple perfil" },
  { name: "Cliente no valida Direccion", code: "Cliente no valida Direccion" },
  { name: "Cliente no valida Rut", code: "Cliente no valida Rut" },
];

const NIVEL_OPTIONS = [
  { name: "TEAM-WORK", code: "ALL" },
  { name: "AUTOMATICO", code: "AUTO" },
  { name: "PROCESO", code: "BUSQUEDA" },
  { name: "CLIENTE", code: "CLIENTE" },
];

interface IActionMassiveInhabilitada {
  listadoSeleccionado: string[];
  localStorageFilter: string;
  setFormFilter: Function;
  formFilter: any;
  listRefresh: Function;
}

const ActionMassiveInhabilitada = (props: IActionMassiveInhabilitada) => {
  const {
    listadoSeleccionado,
    localStorageFilter,
    setFormFilter,
    formFilter,
    listRefresh,
  } = props;
  const { profile, downloadExcelInhabilitados } = useContext(SeleccionContext);
  const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
  const [openModalRestaurar, setOpenModalRestaurar] = useState<boolean>(false);
  const [openModalCarga, setOpenModalCarga] = useState<boolean>(false);
  const [openModalCargaManual, setOpenModalCargaManual] = useState<boolean>(false);
  const [openModalFiltro, setOpenModalFiltro] = useState<boolean>(false);
  const [dataObject, setDataObject] = useState<boolean | undefined>(undefined);
  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean>(false);

  const handleClickDownloadExcel = async () => {
    if (isLoadingExcel) return;
    const stored = localStorage.getItem(localStorageFilter);
    const filtros = stored ? JSON.parse(stored) : formFilter;
    await downloadExcelInhabilitados({ filtros, setIsLoadingExcel });
  };

  useEffect(() => {
    setButtonEnabled(listadoSeleccionado.length > 0);
  }, [listadoSeleccionado]);

  useEffect(() => {
    if (localStorage.getItem(localStorageFilter)) {
      const copyStorage: any = localStorage.getItem(localStorageFilter);
      const hasValues = Object.values(JSON.parse(copyStorage)).some(
        (value: any) => Array.isArray(value) && value.length > 0
      );
      setDataObject(hasValues);
    }
  }, [localStorage.getItem(localStorageFilter)]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 6,
        }}
      >
        <div className="container-actions margin-0">
          <div className="content-actions-masive">
          {PROFILE_ADMIN_SEL.includes(profile) && (
            <Tooltip text="Revertir inhabilitación">
              <button
                className={`button-actions ${buttonEnabled ? "active-restore" : "disabled"}`}
                disabled={!buttonEnabled}
                style={{ transform: "rotateY(180deg)" }}
                onClick={() => setOpenModalRestaurar(true)}
              >
                <RefreshRoundedIcon />
              </button>
            </Tooltip>
          )}

          {/* Cargar Nómina disponible para todos los perfiles, sin gate. */}
          <Tooltip text="Cargar Nómina">
            <button
              className={`button-actions active-azul`}
              onClick={() => setOpenModalCarga(true)}
            >
              <UploadFileRoundedIcon />
            </button>
          </Tooltip>

          {/* Carga manual: mismos pasos que la nómina, pero escribiendo los RUT. */}
          <Tooltip text="Cargar manualmente">
            <button
              className={`button-actions active-azul`}
              onClick={() => setOpenModalCargaManual(true)}
            >
              <PersonAddAlt1RoundedIcon />
            </button>
          </Tooltip>

          <Tooltip text="Descargar Nómina">
            <button
              className={`button-actions ${
                isLoadingExcel ? "disabled file" : "active-file"
              }`}
              onClick={handleClickDownloadExcel}
              disabled={isLoadingExcel}
            >
              {isLoadingExcel ? (
                <IconCargando fill="#327a30" />
              ) : (
                <IconDescargaNomina fill="#327a30" />
              )}
            </button>
          </Tooltip>

          <button
            className={`button-actions`}
            onClick={() => setOpenModalFiltro(true)}
          >
            {dataObject ? (
              <IconFilterFull fill="#3B6597" />
            ) : (
              <IconFilter fill="#3B6597" />
            )}
          </button>
          </div>
        </div>
        <FilterChips
          localStorageFilter={localStorageFilter}
          setFormFilter={setFormFilter as (val: any) => void}
          labels={INHAB_FILTER_LABELS}
        />
      </div>

      {openModalFiltro && (
        <FiltroGenerico
          title="Filtros"
          localStorageFilter={localStorageFilter}
          onBack={() => setOpenModalFiltro(false)}
          onValueChange={setFormFilter}
          onPropertyChange={formFilter}
        >
          <InputFiltro
            layer="RUT"
            typeFilter="rut"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="dni"
          />
          <InputFiltro
            layer="NOMBRE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="nombre"
          />
          <DropDownListMultipleFiltro
            layer="MOTIVO"
            list={TIPO_OPTIONS}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="tipo"
          />
          <DropDownListMultipleFiltro
            layer="TIPO"
            list={NIVEL_OPTIONS}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="nivel"
          />
          <InputFiltro
            layer="CLIENTE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="clienteNombre"
          />
          <InputFiltro
            layer="AREA NEGOCIO"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="areaNegocioCod"
          />
          <InputFiltro
            layer="PROCESO"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="busquedaId"
          />
          <InputFiltro
            layer="USUARIO"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="usuario"
          />
          <InputFiltro
            layer="FECHA INHABILITACION"
            typeFilter="date"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="fecha"
          />
        </FiltroGenerico>
      )}

      {openModalRestaurar && (
        <ModalRestaurarInhabilitada
          list={listadoSeleccionado}
          listRefresh={listRefresh}
          onChangeBack={() => setOpenModalRestaurar(false)}
          title="REVERTIR INHABILITACIÓN DE CANDIDATOS"
          message="Estás por quitar inhabilidad a la siguiente selección:"
        />
      )}

      <CargaNominaInhabilitados
        visible={openModalCarga}
        onHide={() => setOpenModalCarga(false)}
        onLoaded={() => listRefresh && listRefresh()}
      />

      <CargaManualInhabilitados
        visible={openModalCargaManual}
        onHide={() => setOpenModalCargaManual(false)}
        onLoaded={() => listRefresh && listRefresh()}
      />
    </>
  );
};

export default ActionMassiveInhabilitada;
